import { LeftOutlined } from '@ant-design/icons';
import { Layout, Row, Typography } from 'antd';
import classNames from 'classnames/bind';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '~/store/store';

import styles from './index.module.scss';

const { Title } = Typography;

const cx = classNames.bind(styles);

interface ContentProps {
  title?: string | null;
  backText?: string | null;
  link?: string;
  children: React.ReactNode;
  isAuthenticated?: boolean;
}

const Content = ({
  title,
  backText,
  link,
  children,
  isAuthenticated,
}: ContentProps): React.ReactElement => {
  const auth = useSelector((state: RootState): any => state.auth);

  const showAuthWrapper =
    isAuthenticated === undefined ? auth.isAuthenticated : isAuthenticated;

  return (
    <>
      {showAuthWrapper && (
        <div className={cx('title-wrapper')}>
          <Title className={cx('title')} level={4}>
            {title}
          </Title>
          <Row align="middle" style={{ height: '30px' }}>
            {link && (
              <>
                <LeftOutlined style={{ color: '#7E6DD6' }} />
                <Link className={cx('text-link')} to={link}>
                  {backText}
                </Link>
              </>
            )}
          </Row>
        </div>
      )}
      <Layout.Content
        className={cx({
          'content-wrapper': showAuthWrapper,
          'auth-content-wrapper': !showAuthWrapper,
        })}
      >
        {children}
      </Layout.Content>
    </>
  );
};

export default Content;
